module.exports = __webpack_public_path__ + "static/media/boek_02.ce50dee7.png";